const Images = {
    orders: require('../assets/images/orders.png'),
    dashboard: require('../assets/images/dashboard.png'),
    logout: require('../assets/images/logout.png'),
    product: require('../assets/images/Xpanse.png'),
    xpanse: require('../assets/images/Xpanse.png'),
    beans: require('../assets/images/beans.png'),
    profile: require('../assets/images/profile.png'),
    reviews: require('../assets/images/REVIEWS.png'),
    emptyGif: require('../assets/images/emptyCart.json'),
    emptyCart: require('../assets/images/emptyCartImage.webp'),
    emptyCartImg: require('../assets/images/emptyCart.webp'),

    card: require('../assets/images/card.png'),
    cash: require('../assets/images/cash.png'),
    upi: require('../assets/images/upi.png'),

    noProductSelected: require('../assets/images/emptybox.png'),
    noOrders: require('../assets/images/noOrders.png'),
    qrImage: require('../assets/images/QRimage.png'),
    invoiceLogo: require('../assets/images/invoice-logo.webp'),

    errorScreen: require('../assets/images/errorScreen.webp'),
    xpanseLabel: require('../assets/images/xpanceLabel.png'),

    // Thumbnails
    loginProcess: require('../assets/images/thumbnails/loginProcess.webp'),
    dashboardOverView: require('../assets/images/thumbnails/dashboardOverView.webp'),
    outletManagement: require('../assets/images/thumbnails/outletManagement.webp'),
    outletOffers: require('../assets/images/thumbnails/outletOffers.webp'),
    productStockManagement: require('../assets/images/thumbnails/productStockManagement.webp'),
    addonStockManagement: require('../assets/images/thumbnails/addonsStockManagement.webp'),
    ordersReport: require('../assets/images/thumbnails/ordersReport.webp'),
    criticalStockReport: require('../assets/images/thumbnails/criticalStockReport.webp'),
    stockTransactionReport: require('../assets/images/thumbnails/stockTransactionReports.webp'),
    paymentTransactionReport: require('../assets/images/thumbnails/paymentTransactions.webp'),
    complimentaryOrder: require('../assets/images/thumbnails/complimentaryOrder.webp'),
    orderNotReceieved: require('../assets/images/thumbnails/orderNotReceieved.webp'),
    damagedRawMaterial: require('../assets/images/thumbnails/damagedRawMaterial.webp'),
    posSupport: require('../assets/images/thumbnails/posSupport.webp'),
    customerSupport: require('../assets/images/thumbnails/customerSupport.webp'),
    inventoryStockListing: require('../assets/images/thumbnails/inventoryStockListing.webp'),
    productsListing: require('../assets/images/thumbnails/productsListing.webp'),
    labelPrinter: require('../assets/images/thumbnails/labelPrinter.webp'),
    controllingProduct: require('../assets/images/thumbnails/controllingProduct.webp'),
}

export default Images;